import useSWR from 'swr';
import urlResolver from 'admin/utils/URLResolver';
import { getter } from 'core/utils';

export const useGroupActivityResponses = (activityId) => {
  const url = urlResolver.reverse('api:activities:responses-collaborated', {
    activityId,
  });

  const { data, error } = useSWR(url, getter);

  if (error) {
    console.error(error);
  }

  return {
    data,
    loading: !data && !error,
    error,
  };
};
